module.exports = __webpack_public_path__ + "img/whatsap.1e1fd2b.svg?v=1791296779994";